import axios from 'axios';
import authHeader from './authHeader';
import RetryPolicy from './RetryAuthProblems'

const API_URL = process.env.REACT_APP_API_URL;
const axiosApiInstanceForValidation = axios.create();

axiosApiInstanceForValidation.interceptors.response.use(response => {
    return response;
}, async error => RetryPolicy(error));

class FarmsService {

    getFarms() {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms', { headers: authHeader() });
    }

    getFilteredFarms(queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + queryString, {
            headers: authHeader()
        });
    }

    getFarm(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId, { headers: authHeader() });
    }

    insertarFarm(farm) {
        return axiosApiInstanceForValidation.post(API_URL + '/v3/farms', farm, { headers: authHeader() });
    }

    updateFarm(farmId, farmData) {
        return axiosApiInstanceForValidation.patch(API_URL + '/v3/farms/' + farmId, farmData, { headers: authHeader() });
    }

    deleteFarm(farmId) {
        return axiosApiInstanceForValidation.delete(API_URL + '/v3/farms/' + farmId, { headers: authHeader() });
    }

    getFarmsDashboard(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/dashboard', { headers: authHeader() });
    }

    getFarmContacts(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/contacts', { headers: authHeader() });
    }

    getFarmLocations(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/locations', { headers: authHeader() });
    }

    getFilteredFarmLocations(farmId, queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/locations/' + queryString, {
            headers: authHeader()
        });
    }

    getFarmStoragePoints(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/storagePoints', { headers: authHeader() });
    }

    getFilteredFarmStoragePoints(farmId, queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/storagePoints/' + queryString, {
            headers: authHeader()
        });
    }

    getFarmMovements(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/movements', { headers: authHeader() });
    }

    getFarmMovement(farmId, movementId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/movements/' + movementId, { headers: authHeader() });
    }

    getFilteredFarmMovements(farmId, queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/movements/' + queryString, {
            headers: authHeader()
        });
    }

    getFarmReceipts(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/receipts', { headers: authHeader() });
    }

    getFilteredFarmReceipts(farmId, queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/receipts/' + queryString, {
            headers: authHeader()
        });
    }

    getFarmGroups(farmId) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/groups', { headers: authHeader() });
    }

    getFilteredFarmGroups(farmId, queryString) {
        return axiosApiInstanceForValidation.get(API_URL + '/v3/farms/' + farmId + '/groups/' + queryString, {
            headers: authHeader()
        });
    }
}

export default new FarmsService();